import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as companyDocumentTypes from './companyDocumentTypes';

const byId = handleActions(
  {
    [companyDocumentTypes.COMPANY_DOCUMENT_LIST_FOR_COMPANY.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload.entities.companyDocuments,
    }),
  },
  {},
);

const allIds = handleActions(
  {
    [companyDocumentTypes.COMPANY_DOCUMENT_LIST_FOR_COMPANY.SUCCESS]: (state, { payload }) => [
      ...new Set([...state, ...payload.result]),
    ],
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
